import { useState } from "react";
import clsx from "clsx";
import { Select as SelectProps } from "./index.types";
import "./index.css";
import Button from "../button";
import { TfiAngleDown } from "react-icons/tfi";
import Input from "../input";

export function Select({
  inputClassName = "",
  classNameGroup = "",
  options,
  styleGroup,
  defaultValue,
  setFormSelected,
  clearError,
  resetForm,
  onFormBlur,
  handleSelect,
  label,
  labelClassName,
  error,
  backgroundColor,
  isRequired,
  ...rest
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(defaultValue || (options && options[0]));
  const [filteredOptions, setFilteredOptions] = useState(options);
  const { name } = rest;

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleInputClose = () => {
    if (onFormBlur) {
      onFormBlur();
    }
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleValueChange = (e: { target: { value: string } }) => {
    const { value } = e.target;
    const filtered = options?.filter((v) => v.includes(value));
    setFilteredOptions(filtered);
    setValue(value);
  };

  const handleSelectChange = (e: { target: { name: string } }) => {
    const { name: value } = e.target;

    if (setFormSelected) {
      setFormSelected(name, value);
      if (clearError) {
        clearError(name);
      }

      if (resetForm) {
        resetForm();
      }
    } else {
      setValue(value);
    }

    if (handleSelect) {
      handleSelect(value);
    }

    handleClose();
  };

  return (
    <div
      className={clsx("select-group", classNameGroup)}
      style={{ backgroundColor: backgroundColor, ...styleGroup }}
    >
      <Input
        inputClassName={clsx(
          "select",
          {
            "select--focus": isOpen,
          },
          inputClassName
        )}
        value={value}
        error={error}
        required={isRequired}
        placeholder="Select a value"
        icon={{
          className: "select__arrow",
          element: (
            <Button
              type="button"
              size="large"
              mode="icon"
              className={clsx("select__arrow-button", {
                "select__arrow-button--open": isOpen,
              })}
              onClick={handleToggle}
              onBlur={handleClose}
            >
              <TfiAngleDown size={24} />
            </Button>
          ),
        }}
        onFocus={handleOpen}
        onBlur={handleInputClose}
        onChange={handleValueChange}
        autoComplete="off"
        label={label}
        labelClassName={labelClassName}
        {...rest}
      />
      {isOpen && (
        <div className="select__box">
          {(filteredOptions as string[]).map(
            (option: string, index: number) => (
              <Button
                key={`index-${index}`}
                type="button"
                mode="secondary"
                className="select__option"
                name={option}
                title={option}
                onMouseDown={handleSelectChange as any}
              >
                {option}
              </Button>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default Select;
